import { createTheme, themes } from '@ace-clublabs/shared-component-library';
import type { ThemeOptions } from '@mui/material';
import '@mui/x-date-pickers/themeAugmentation';

const defaultTheme = themes.light;

export const lightTheme = createTheme(defaultTheme, {
  palette: {
    background: {
      default: '#F7F5F1',
    },
  },
  components: {
    MuiModal: {
      defaultProps: {
        disablePortal: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disablePortal: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        disablePortal: true,
      },
    },
    MuiPopper: {
      defaultProps: {
        disablePortal: true,
      },
    },
  },
} satisfies ThemeOptions);
